<ng-container>

  <!-- ===========================
    Dynamic Layout: label ↔ input
  =========================== -->
  <ng-container *ngTemplateOutlet="topSectionTpl; context: { $implicit: templateContext }" />
  <ng-container *ngTemplateOutlet="bottomSection; context: { $implicit: templateContext }" />

  <!-- ===========================
    feedbackType Outlet
  =========================== -->
  @if (touched && (feedbackValidMsg || invalid)) {
    <div [appFormFieldFeedback]="dynamicFeedbackUI" [feedbackProvider]="feedbackProvider">
      <ng-container 
        *ngTemplateOutlet="getTemplate('feedbackMsg')?.templateRef ?? feedbackMsgTpl; context: feedbackContext" />
    </div>
  }

  <!-- ===========================
    TextHelp Outlet
  =========================== -->
  <ng-container 
    *ngTemplateOutlet="getTemplate('textHelp')?.templateRef ?? textHelpTpl; context: { $implicit: textHelp }" />

</ng-container>


<!-- ===========================
  Label Block
=========================== -->
<ng-template #labelTpl>
  @if (label) {
    <label [attr.for]="id" class="form-label" [ngClass]="labelClassStyle">{{label}}</label>
  }
</ng-template>

<!-- ===========================
  Input Field Block
=========================== -->
<ng-template #inputFieldTpl>
  <input 
    appFormFieldStatus
    appFormInputField
    [ignoreStatus]="ignoreStatus"
    (blur)="onInputTouched()"
    (input)="onInputChange($event)"
    [id]="id"
    [size]="size"
    [type]="type"
    [name]="name"
    [value]="value"
    [rounded]="isRounded"
    [disabled]="disabled"
    [readonly]="readonly"
    [required]="required"
    [plaintext]="isPlaintext"
    [placeholder]="placeholder"
    [attr.min]="isIntegerInput && min"
    [attr.max]="isIntegerInput && max"
    [attr.step]="isInputRange && step"
    [attr.aria-label]="ariaLabel ?? label"
    [class.p-0]="isInputColor"
    [attr.aria-describedby]="described ?? label ?? textHelp" />
</ng-template>

<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #textHelpTpl let-textHelp>
  @if (textHelp) {
    <div class="form-text" [ngClass]="textHelpClassStyle">{{textHelp}}</div>
  }
</ng-template>

<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #feedbackMsgTpl let-msg>
  {{msg}}
</ng-template>